import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { DarkModeContext } from '../context/DarkModeContext';
import { COLORS } from './constants';

const Paragraph = ({ text }) => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	return <ParagraphStyled isDarkModeOn={isDarkModeOn}>{text}</ParagraphStyled>;
};

export default Paragraph;

// 🎨 Styled Components
const ParagraphStyled = styled.div`
	font-size: calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
	font-family: 'Montserrat', sans-serif;
	font-weight: 300;
	line-height: 1.8;
	text-align: left;
	color: ${COLORS.lightGrey};
	&::selection{
		background-color:${COLORS.somOrange};
		color:${COLORS.white}
	}
	/* ${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.white};
		`} */
`;
